import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelHeadingComponent } from './panel-heading.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    PanelHeadingComponent,
  ],
  declarations: [
    PanelHeadingComponent
  ]
})
export class PanelHeadingModule { }
